import { useEffect } from 'react';
import { navigate } from 'gatsby';

export default () => {

  useEffect(() => {

    navigate('/error_404');

  }, []);

  return null;

};
